export default "https://cdn.questicon.mathletics.com/assets/audio/scoreResults3Star-ab9e4ad937ee6fadaab535be8c8a5682.mp3";